"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowQuickViewButton = void 0;
var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};
var shouldShowQuickViewButton = exports.shouldShowQuickViewButton = function shouldShowQuickViewButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _product$customerNoti = product.customerNotifiableEvents,
    _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
    backInStock = _product$customerNoti2.backInStock,
    newlyInStock = _product$customerNoti2.newlyInStock,
    onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
    onRelease = _product$customerNoti2.onRelease,
    isFabricByLength = product.isFabricByLength,
    isInStoreOnly = product.isInStoreOnly,
    isMadeToMeasure = product.isMadeToMeasure,
    isOutlet = product.isOutlet,
    outOfStock = product.outOfStock,
    price = product.price,
    type = product.type;
  var isPreorderBackInStock = backInStock && outOfStock;
  var isFutureRelease = isPreorderBackInStock || newlyInStock || onPreorderLaunch || onRelease;
  var productHasPrice = (price === null || price === void 0 ? void 0 : price.now) !== undefined && Number(price === null || price === void 0 ? void 0 : price.now) !== 0;
  if (!productHasPrice || isFabricByLength || isInStoreOnly || isMadeToMeasure || isOutlet || outOfStock && !isFutureRelease || type === 'asaf' || type === 'bundle' || type === 'productSet') {
    return false;
  }
  return true;
};